import axios from "axios";

export class ValidationCheckRepository {

  async getAccessToken() {

    const baseAuthUrlAPI = process.env.REACT_APP_AUTH_BASE_URL_API;
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_CLIENT_SECRET;

    const authUrl = baseAuthUrlAPI + "/auth";

    try {
      const response = await axios.post(
        authUrl,
        {
          client_id: clientId,
          client_secret: clientSecret
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      return response.data.access_token;
    } catch (error) {
      console.error("Erro ao obter token de acesso:", error);
      throw new Error("Erro na autenticação");
    }
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  async validationCheck(documentNumber) {
    const token = await this.getAccessToken();
    const apiUrl = process.env.REACT_APP_BASE_URL_API + "/backgroundcheck/validations/check";

    let uid = null;
    let firstAttempt = true;

    while (true) {
      try {
        const payload = firstAttempt
          ? { documentNumber }
          : { uid, documentNumber };

        const response = await axios.post(apiUrl, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          validateStatus: () => true // permite lidar com 202 manualmente
        });

        if (response.status === 200) {
          const validationResults = response.data?.validationResults;

          const summary = validationResults?.summary ?? "";
          const results = Array.isArray(validationResults?.results)
            ? validationResults.results.map(({ company, logo, allowed }) => ({ company, logo, allowed }))
            : [];
          const dataUnavailable = response.data?.dataUnavailable ?? null;

          return { summary, results, dataUnavailable };
        }

        if (response.status === 202) {
          console.log("Processamento em andamento...");
          if (firstAttempt) {
            uid = response.data.uid;
            if (!uid) {
              throw new Error("UID não retornado na primeira chamada.");
            }
            firstAttempt = false;
          }
          await this.delay(10000); // espera 10 segundos
          continue;
        }

        // qualquer outro status = erro
        throw new Error(`Erro inesperado: ${response.status} - ${JSON.stringify(response.data)}`);

      } catch (error) {
        console.error("Erro no processo de validação:", error);
        throw new Error("Erro durante a validação do cliente");
      }
    }
  }
}
